/*
 * Shopify Common JS
 *
 */

if (typeof window.Shopify == "undefined") {
	window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments)
	}
}

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i]
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i
			return i
		}
	}
}

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent("on" + eventName, callback)
}

Shopify.postLink = function (path, options) {
	options = options || {}
	var method = options["method"] || "post"
	var params = options["parameters"] || {}

	var form = document.createElement("form")
	form.setAttribute("method", method)
	form.setAttribute("action", path)

	for (var key in params) {
		var hiddenField = document.createElement("input")
		hiddenField.setAttribute("type", "hidden")
		hiddenField.setAttribute("name", key)
		hiddenField.setAttribute("value", params[key])
		form.appendChild(hiddenField)
	}
	document.body.appendChild(form)
	form.submit()
	document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options
) {
	this.countryEl = document.getElementById(country_domid)
	this.provinceEl = document.getElementById(province_domid)
	this.provinceContainer = document.getElementById(
		options["hideElement"] || province_domid
	)

	Shopify.addListener(
		this.countryEl,
		"change",
		Shopify.bind(this.countryHandler, this)
	)

	this.initCountry()
	this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute("data-default")
		Shopify.setSelectorByValue(this.countryEl, value)
		this.countryHandler()
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute("data-default")
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value)
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex]
		var raw = opt.getAttribute("data-provinces")
		var provinces = JSON.parse(raw)

		this.clearOptions(this.provinceEl)
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = "none"
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option")
				opt.value = provinces[i][0]
				opt.innerHTML = provinces[i][1]
				this.provinceEl.appendChild(opt)
			}

			this.provinceContainer.style.display = ""
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild)
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option")
			opt.value = values[i]
			opt.innerHTML = values[i]
			selector.appendChild(opt)
		}
	},
}



function listView() {
	$('#list_view').css('display', 'none');
	$('#grid_view').css('display', 'block');
	$('.product-new-view').removeClass('new-product-grid');
}
function gridView() {
	$('#list_view').css('display', 'block');
	$('#grid_view').css('display', 'none');
	$('.product-new-view').addClass('new-product-grid');
}


function topFunction() {
	$("html, body").animate({
		scrollTop: 0
	}, "slow");
	return false
}


$(document).ready(function () {

	// === INITIAL HEADER STATE FROM THEME SETTINGS ===
	let desktopLogoColor = $('.top-header').data('desktop-logo');
	let mobileLogoColor = $('.top-header').data('mobile-logo');
	let desktopNavColor = $('.top-header').data('desktop-nav');
	let mobileNavColor = $('.top-header').data('mobile-nav');

	// Default fallback
	if (!desktopLogoColor) desktopLogoColor = 'black';
	if (!mobileLogoColor) mobileLogoColor = 'black';
	if (!desktopNavColor) desktopNavColor = 'black';
	if (!mobileNavColor) mobileNavColor = 'black';

	// Set initial logo visibility for desktop
	if (desktopLogoColor === 'white') {
		$('.white_home_logo.indexDesk').show();
		$('.black_home_logo.indexDesk').hide();
	} else {
		$('.white_home_logo.indexDesk').hide();
		$('.black_home_logo.indexDesk').show();
	}

	// Set initial logo visibility for mobile
	if (mobileLogoColor === 'white') {
		$('.white_home_logo.indexMobile').show();
		$('.black_home_logo.indexMobile').hide();
	} else {
		$('.white_home_logo.indexMobile').hide();
		$('.black_home_logo.indexMobile').show();
	}

	// Set navigation text color
	if (desktopNavColor === 'white') {
		$(".home_menu_white .new-header-menus ul").css("color", "#fff");
		$(".home_menu_white nav ul.flex.flex-wrap.justify-end").css("color", "#fff");
		$(".home_menu_white .fa").css("color", "#fff");
	} else {
		
		$(".home_menu_white .new-header-menus ul").css("color", "#000");
		$(".home_menu_white nav ul.flex.flex-wrap.justify-end").css("color", "#000");
		$(".home_menu_white .fa").css("color", "#000");
	}

	// Set Mobile navigation text color
	if (mobileNavColor === 'white') {
		$(".homeMobileMenuClass .mobileMenuClass").attr("style", "color: #fff !important");
	} else {
		
		if(currentTemplate.trim() === 'index'){
			$("i.fa.fa-user").attr("style", "color: #FFF ");
			$("i.fa.fa-search").attr("style", "color: #FFF ");
			$(".link.mobileMenuClass").attr("style", "color: #fff");
		}else{
			$(".homeMobileMenuClass .mobileMenuClass").attr("style", "color: #000 !important");
		}
		
	}

	$('body').on('click', 'input#search', function ()
	{
		if (desktopNavColor === 'white')
		{
			$('.home_menu_white .new-header-menus ul').css('color', '#000');
			$('.home_menu_white nav ul.flex.flex-wrap.justify-end').css('color', '#000');
			$(".home_menu_white .fa").css("color", "#000");
		}
		else
		{
			$(".home_menu_white .new-header-menus ul").css("color", "#fff");
			$(".home_menu_white nav ul.flex.flex-wrap.justify-end").css("color", "#fff");
		}
	});

	let header_ready_to_wear_counter = 0;
	let header_newarrivals_counter = 0;
	let header_more_counter = 0;
	let header_search_counter = 0;

	$("li.mr-3.desktop-search").click(function ()
	{
		header_search_counter++;
		if (header_search_counter % 2 != 0)
		{
			if (desktopNavColor === 'white')
			{
				$('.home_menu_white .new-header-menus ul').css('color', '#000');
				$('.home_menu_white nav ul.flex.flex-wrap.justify-end').css('color', '#000');
				$(".home_menu_white .fa").css("color", "#000");
			}
			$(".top-header").toggleClass('back-color');
			$('this').toggleClass('back-color');

			$('.desk_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/image_1.png?v=1714802245');
			$('.mob_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/image_1.png?v=1714802245');

			//$('.white_home_logo').css('display','none');
			//$('.black_home_logo').css('display','block');
		}
		else
		{
			if (desktopNavColor === 'white')
			{
				$('.home_menu_white .new-header-menus ul').css('color', '#fff');
				$('.home_menu_white nav ul.flex.flex-wrap.justify-end').css('color', '#fff');
				$(".home_menu_white .fa").css("color", "#fff");
			}
			$(".top-header").toggleClass('back-color');
			$('this').toggleClass('back-color');

			$('.desk_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/Veronica-de-Piante-Monogram-Layered-White.png?v=1714802324');
			$('.mob_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/Veronica-de-Piante-Monogram-Layered-White.png?v=1714802324');
			
			//$('.white_home_logo').css('display','block');
			//$('.black_home_logo').css('display','none');
		}
	});

	$(".button.header_ready_to_wear_link").click(function (e) {
		header_newarrivals_counter = 0;
		header_more_counter = 0;
		header_ready_to_wear_counter++;

		if (header_ready_to_wear_counter % 2 != 0)
		{
			if (desktopNavColor === 'white')
			{
				$('.home_menu_white .new-header-menus ul').css('color', '#000');
				$('.home_menu_white nav ul.flex.flex-wrap.justify-end').css('color', '#000');
				$(".home_menu_white .fa").css("color", "#000");
			}
			
			$(".header_newarrivals_sub_link").css('display', 'none');
			$(".header_ready_to_wear_sub_link").css('display', 'block');
			$(".header_more_sub_ink").css('display', 'none');
			$('.top-header').addClass('back-color');

			$('.desk_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/image_1.png?v=1714802245');
			$('.mob_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/image_1.png?v=1714802245');
			//$('.white_home_logo').css('display','none');
			//$('.black_home_logo').css('display','block');
		}
		else
		{
			if (desktopNavColor === 'white')
			{
				$('.home_menu_white .new-header-menus ul').css('color', '#fff');
				$('.home_menu_white nav ul.flex.flex-wrap.justify-end').css('color', '#fff');
				$(".home_menu_white .fa").css("color", "#fff");
			}

			$(".header_ready_to_wear_sub_link").css('display', 'none');
			$(".header_newarrivals_sub_link").css('display', 'none');
			$(".header_more_sub_ink").css('display', 'none');
			$('.top-header').removeClass('back-color');

			$('.desk_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/Veronica-de-Piante-Monogram-Layered-White.png?v=1714802324');
			$('.mob_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/Veronica-de-Piante-Monogram-Layered-White.png?v=1714802324');
			
			//$('.white_home_logo').css('display','block');
			//$('.black_home_logo').css('display','none');       
		}
	});

	$(".button.header_newarrivals_ink").click(function (e) {
		header_ready_to_wear_counter = 0;
		header_newarrivals_counter++;
		
		if (header_newarrivals_counter % 2 != 0)
		{
			if (desktopNavColor === 'white')
			{
				$('.home_menu_white .new-header-menus ul').css('color', '#000');
				$('.home_menu_white nav ul.flex.flex-wrap.justify-end').css('color', '#000');
				$(".home_menu_white .fa").css("color", "#000");
			}

			$(".header_ready_to_wear_sub_link").css('display', 'none');
			$(".header_newarrivals_sub_link").css('display', 'block');
			$(".header_more_sub_ink").css('display', 'none');
			$('.top-header').addClass('back-color');

			$('.desk_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/image_1.png?v=1714802245');
			$('.mob_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/image_1.png?v=1714802245');

			//$('.white_home_logo').css('display','none');
			//$('.black_home_logo').css('display','block');

		}
		else
		{
			if (desktopNavColor === 'white')
			{
				$('.home_menu_white .new-header-menus ul').css('color', '#fff');
				$('.home_menu_white nav ul.flex.flex-wrap.justify-end').css('color', '#fff');
				$(".home_menu_white .fa").css("color", "#fff");
			}

			$(".header_newarrivals_sub_link").css('display', 'none');
			$(".header_ready_to_wear_sub_link").css('display', 'none');
			$(".header_more_sub_ink").css('display', 'none');
			$('.top-header').removeClass('back-color');

			$('.desk_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/Veronica-de-Piante-Monogram-Layered-White.png?v=1714802324');
			$('.mob_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/Veronica-de-Piante-Monogram-Layered-White.png?v=1714802324');
			

			//$('.white_home_logo').css('display','block');
			//$('.black_home_logo').css('display','none');
		}
	});

	$(".button.header_more_ink").click(function (e) {
		header_ready_to_wear_counter = 0;
		header_newarrivals_counter = 0;
		header_more_counter++;

		if (header_more_counter % 2 != 0)
		{
			if (desktopNavColor === 'white')
			{
				$('.home_menu_white .new-header-menus ul').css('color', '#000');
				$('.home_menu_white nav ul.flex.flex-wrap.justify-end').css('color', '#000');
				$(".home_menu_white .fa").css("color", "#000");
			}
			$(".header_ready_to_wear_sub_link").css('display', 'none');
			$(".header_newarrivals_sub_link").css('display', 'none');
			$(".header_more_sub_ink").css('display', 'block');
			$('.top-header').addClass('back-color');

			$('.desk_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/image_1.png?v=1714802245');
			$('.mob_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/image_1.png?v=1714802245');

			//$('.white_home_logo').css('display','none');
			//$('.black_home_logo').css('display','block');
		}
		else
		{
			if (desktopNavColor === 'white')
			{
				$('.home_menu_white .new-header-menus ul').css('color', '#fff');
				$('.home_menu_white nav ul.flex.flex-wrap.justify-end').css('color', '#fff');
				$(".home_menu_white .fa").css("color", "#fff");
			}
			$(".header_newarrivals_sub_link").css('display', 'none');
			$(".header_ready_to_wear_sub_link").css('display', 'none');
			$(".header_more_sub_ink").css('display', 'none');
			$('.top-header').removeClass('back-color');

			$('.desk_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/Veronica-de-Piante-Monogram-Layered-White.png?v=1714802324');
			$('.mob_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/Veronica-de-Piante-Monogram-Layered-White.png?v=1714802324');
			
			
			//$('.white_home_logo').css('display','block');
			//$('.black_home_logo').css('display','none');
		}

	});

	$(".new-header-menus ul li a").click(function () {
		$(".header_ready_to_wear_sub_link").css('display', 'none');
		$(".header_newarrivals_sub_link").css('display', 'none');
		$(".header_more_sub_ink").css('display', 'none');
		$(".top-header").removeClass('back-color');

		$('.desk_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/Veronica-de-Piante-Monogram-Layered-White.png?v=1714802324');
		$('.mob_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/Veronica-de-Piante-Monogram-Layered-White.png?v=1714802324');
	});
});

$(document).ready(function ()
{
	$("button.form-field__submit.button.button--primary").click(function () {
		$(".top-header").toggleClass('back-color');
		$('this').toggleClass('back-color');
	});

	$('#search').on('keyup', function () {
		var search_length = $('#search').val().trim().split(' ');

		if (search_length != '') {
			$('#search-form .overflow-y-scroll').addClass("search_suggestion_box");
		} else {
			$('#search-form .overflow-y-scroll').removeClass("search_suggestion_box");
		}
	});
});

$(window).scroll(function () {

	check_from_top_de();
});

function check_from_top_de() {
	var scroll = $(window).scrollTop();

	if (!$('.top-header').hasClass('back-color')) {
		if (scroll >= 900) {
			//      $(".home_menu_white .new-header-menus ul").css("color","#1e1e1e"); 
			//      $(".home_menu_white nav ul.flex.flex-wrap.justify-end").css("color","#1e1e1e"); 
		} else {
			//      $(".home_menu_white .new-header-menus ul").css("color","#ffffff");
			//     $(".home_menu_white nav ul.flex.flex-wrap.justify-end").css("color","#ffffff");
		}
	}
}

$(document).ready(function () {
	$('body').on('click', 'li.mr-3.desktop-search.new-desktop-seach .fa.fa-search', function () {

		$('.top-header').removeClass('back-color');
		$(".home_menu_white .new-header-menus ul").css("color", "#fff");
		$(".home_menu_white nav ul.flex.flex-wrap.justify-end").css("color", "#fff");

		$('.desk_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/image_1.png?v=1714802245');
		$('.mob_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/image_1.png?v=1714802245');

		//$('.white_home_logo').css('display','block');
		//$('.black_home_logo').css('display','none');
	});
});

$(document).ready(function () {
	// $(".video-parent video").attr("playsinline","");

	$('body').on('click', 'div#search-form ', function () {
		$('.top-header').addClass('back-color');
		$(".home_menu_white .new-header-menus ul").css("color", "#000");
		$(".home_menu_white nav ul.flex.flex-wrap.justify-end").css("color", "#000");

		$('.desk_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/Veronica-de-Piante-Monogram-Layered-White.png?v=1714802324');
		$('.mob_home_page_logo img').attr('src','https://veronicadepiante.com/cdn/shop/files/Veronica-de-Piante-Monogram-Layered-White.png?v=1714802324');
		//$('.white_home_logo').css('display','none');
		//$('.black_home_logo').css('display','block');
	});

	$('.price-details').find("s").css("margin-right", "10px");
	if ($('.price-details span s').is(":visible")) {
		$('.top-line').addClass("markdown-assigned");
	}
});